import { type IDDocument, type IDDocumentType } from '@/types/IDDocument'

export function createIDDocument(data: Partial<IDDocument> = {}): IDDocument {
  const now = new Date()
  return {
    id: data.id ?? crypto.randomUUID?.() ?? `${Date.now()}`,
    personId: data.personId ?? '',
    type: (data.type as IDDocumentType) ?? 'driver_license',
    idNumber: data.idNumber,
    issuer: data.issuer,
    issueDate: data.issueDate,
    expirationDate: data.expirationDate,
    frontImageUrl: data.frontImageUrl,
    backImageUrl: data.backImageUrl,
    barcodeHash: data.barcodeHash,
    rawBarcodeData: data.rawBarcodeData,
    verified: data.verified ?? false,
    notes: data.notes,
    createdAt: data.createdAt ?? now,
    updatedAt: data.updatedAt ?? now,
    isDeleted: data.isDeleted ?? false,
  }
}
